<ng-container *ngIf="showCharts && !loading; else noPainScoreData">
    <div id="topLabel">
        Pain Score Visibility 
        <p-button icon="pi pi-info" [rounded]="true" severity="info" [text]="true" (click)="showPainScoreInfo()"></p-button>
    </div>
    <div id="headerLabel">{{ isDeId(formatName(admin)) }} - {{ medGroup }}</div>
    <div id="ledgerLabel">
        <div>
            <span class="color-square reviewed-user"></span>
            <p class="reviewed-user-legend">Pain score entries recorded by the user under current review</p>
        </div>
        <div>
            <span class="color-circle other-user"></span>
            <p class="other-user-legend">Pain score entries recorded by other users for the same patient</p>
        </div>
    </div>
    <div class="chart-spacer"></div>
    <div id="headerLabel"></div>
    <div class="chart-scroll-container">
        <div id="wrapper" *ngFor="let pt of data.datasets; index as i;">
                <div id="leftChart">
                    <div id="headerLabel">Patient ID: {{isDeId(pt.mrn)}}</div>
                    <div id="headerLabel">Patient Name: {{isDeId(pt.patientName)}}</div>
                    <canvas [id]="pt.id"></canvas> 
                </div>
            </div>
    </div>
</ng-container>
<ng-template #noPainScoreData>
    <ng-container *ngIf="loading === false;">
        <div id="headerLabel">No Pain Score Data Found</div>
    </ng-container>
</ng-template>
<ng-content></ng-content>

<p-dialog header="Pain Score Visibility" appendTo="body" [(visible)]="painScoreInfo" [style]="{width: '30vw'}">
    <p>Each pain score chart below shows a comparison of documented pain scores for a single patient. 
    Entries by the user in review (orange square) are shown alongside entries by other healthcare workers caring 
    for the same patient (white circle). This can help to assess inter‑user pain score documentation patterns.
    </p>
</p-dialog>
